module.exports = __webpack_public_path__ + "img/getImage.152887d0.jpeg";